module.exports = __webpack_public_path__ + "img/Skull.784bb59d.svg";